import { render } from "./VoiceSummaryCard.vue?vue&type=template&id=3662bb72&scoped=true&ts=true"
import script from "./VoiceSummaryCard.vue?vue&type=script&lang=ts"
export * from "./VoiceSummaryCard.vue?vue&type=script&lang=ts"

import "./VoiceSummaryCard.vue?vue&type=style&index=0&id=3662bb72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3662bb72"]])

export default __exports__